module.exports = __webpack_public_path__ + "static/media/canari_logo_noel.64fa3cee.png";